import script from "./performance-analysis.vue?vue&type=script&setup=true&lang=js"
export * from "./performance-analysis.vue?vue&type=script&setup=true&lang=js"

import "./performance-analysis.vue?vue&type=style&index=0&id=0d7fa1c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7fa1c6"]])

export default __exports__